export function getIdParam(props) {
  const { modalID, match, shipment } = props;

  const params = (match || {}).params || {};
  return modalID || params.id || shipment._id;
}
